import { RegionResponse } from '@/modules/api/openapi/models/RegionResponse'
import { monitorBreadcrumb } from '@/modules/monitoring'

/**
 * Transitional shim for non-React, call-time access to the current region —
 * exists only so the legacy `apipyRequest`/`fastApiRequest` helpers can inject
 * `region_id` without reaching into a MobX store, and dies with those helpers.
 *
 * Written/cleared by `SyncRegionIdParam`. Do not add new consumers; use the
 * `useCurrentRegion`/`useRegion` hooks instead.
 */
let currentRegion: RegionResponse | undefined

export const setCurrentRegion = (region: RegionResponse): void => {
  currentRegion = region
  monitorBreadcrumb('currentRegionRef: region set', { regionId: region.regionId })
}

export const clearCurrentRegion = (): void => {
  currentRegion = undefined
  monitorBreadcrumb('currentRegionRef: region cleared')
}

export const getCurrentRegion = (): RegionResponse | undefined => currentRegion
